import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { setIsAddAgainButtonClicked } from "../CreateEmployeeModalSlice";
import { Dispatch } from "redux";
import { JSX } from "react";

interface Props {
    isPostCreateEmployeeLoading: boolean;
    dispatch: Dispatch;
}

export const SubmitButtonComponent = (props: Props): JSX.Element => {
    const { isPostCreateEmployeeLoading, dispatch } = props;

    return (
        <div
            className={
                "c-create-employee-modal__form-group c-create-employee-modal__form-group--button"
            }
        >
            <Button
                type={"submit"}
                variant={"primary"}
                disabled={isPostCreateEmployeeLoading}
                loading={isPostCreateEmployeeLoading}
            >
                Toevoegen
            </Button>
            <Button
                type={"submit"}
                variant={"tertiary"}
                loading={isPostCreateEmployeeLoading}
                disabled={isPostCreateEmployeeLoading}
                onClick={() => dispatch(setIsAddAgainButtonClicked(true))}
            >
                Toevoegen & nieuwe toevoegen
            </Button>
        </div>
    );
};
